import * as e from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/TextT.es.js";
const o = e.forwardRef((t, r) => /* @__PURE__ */ e.createElement(a, { ref: r, ...t, weights: m }));
o.displayName = "TextTIcon";
const n = o;
export {
  n as TextT,
  o as TextTIcon
};
